// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IGetLkTypeResponseSchema {
  isBuilder: boolean;
  lkDealRentSubType?: ELkDealRentSubType;
  lkType: ELkType;
}
export enum ELkDealRentSubType {
  /** Собственник в Сдай/Сними **/
  'Homeowner' = 'homeowner',
  /** Арендатор в Сдай/Сними **/
  'Renter' = 'renter',
  /** Собственник и арендатор в Сдай/Сними **/
  'RenterAndHomeowner' = 'renterAndHomeowner',
}
export enum ELkType {
  /** Собственник **/
  'Homeowner' = 'homeowner',
  /** Поискун **/
  'Searcher' = 'searcher',
  /** Агент **/
  'Specialist' = 'specialist',
}
